import { Injectable } from '@angular/core';
import {NavLink} from '@models/navlink.model';
import {MenuBackoffice} from '@modules/commom/header/componentes/backoffice-header/const/backoffice-menu-config';

@Injectable({
  providedIn: 'root'
})
export class MainMenuBackofficeService {

  constructor() { }

  loadDynamicMenuByUserPermission(rolesUser: string[]): NavLink[] {
    const menu: NavLink[] = [];

    MenuBackoffice.forEach(pai => {
      pai.children.forEach(filho => {
        if (!filho.children || filho.children.length === 0) {
          const optionsAutorizados = filho.roles?.some(valor => rolesUser.includes(valor));

          if (optionsAutorizados) {
            if (!menu.some(item => item.title === pai.title)) {
              menu.push({...pai, children: []});
            }
            menu.filter(item => item.title === pai.title)[0].children.push(filho);
          }
        }
        else {
          filho.children?.filter(neto => {
            return neto.roles?.some(valor => rolesUser.includes(valor)) }).map(netoAutorizado => {
            if (!menu.some(item => item.title === pai.title)) {
              menu.push({...pai, children: []});
            }
            // Verifica se o filho já foi adicionado ao menu
            if (!menu.filter(item => item.title === pai.title)[0].children.some(item => item.title === filho.title)) {
              menu.filter(item => item.title === pai.title)[0].children.push({
                ...filho,
                children: []
              });
            }
            // Adiciona o neto autorizado ao filho correspondente
            menu.filter(item => item.title === pai.title)[0].children
              .filter(item => item.title === filho.title)[0].children.push(netoAutorizado);
          });
        }
      })
    })

    return menu;
  }
}
